import React from 'react';

interface NewYorkGroupHeaderProps {
  groupName: string;
  isFirst?: boolean;
}

const NewYorkGroupHeader: React.FC<NewYorkGroupHeaderProps> = ({ groupName, isFirst = false }) => (
  <div style={{ width: '100%', marginTop: isFirst ? 0 : 12 }}>
    <div style={{ borderTop: '2.5px solid #000', width: '100%' }} />
    <h2
      style={{
        fontWeight: 700,
        textTransform: 'uppercase',
        fontSize: 16,
        lineHeight: '20px',
        margin: '6px 0 4px 0',
        padding: '0 10px',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
      {groupName}
    </h2>
    <div style={{ borderTop: '1px solid #000', width: '100%' }} />
  </div>
);

export default NewYorkGroupHeader;
